import { cn } from './cn';

interface LogoProps {
  size?: number;
  animated?: boolean;
  className?: string;
  title?: string;
}

/**
 * Stackly logomark: five alternating ink/lavender bars on a 64-unit grid.
 * The middle bar spans full width — reads as both a chart-bar "S" and a
 * rising stack. Matches the design system spec.
 */
export const Logo = ({ size = 32, animated = false, className, title = 'Stackly' }: LogoProps) => {
  const bar = { transformBox: 'fill-box' as const, transformOrigin: 'bottom' as const };
  return (
    <svg
      role="img"
      aria-label={title}
      viewBox="0 0 64 64"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={cn('block', className)}
    >
      <title>{title}</title>
      <rect
        x="8" y="14" width="22" height="10" rx="2" fill="#0A0A0A"
        style={{ ...bar, animationDelay: '0ms' }}
        className={animated ? 'animate-bar-rise' : undefined}
      />
      <rect
        x="34" y="14" width="22" height="10" rx="2" fill="#C9B8E0"
        style={{ ...bar, animationDelay: '80ms' }}
        className={animated ? 'animate-bar-rise' : undefined}
      />
      <rect
        x="8" y="27" width="48" height="10" rx="2" fill="#0A0A0A"
        style={{ ...bar, animationDelay: '160ms' }}
        className={animated ? 'animate-bar-rise' : undefined}
      />
      <rect
        x="8" y="40" width="22" height="10" rx="2" fill="#C9B8E0"
        style={{ ...bar, animationDelay: '240ms' }}
        className={animated ? 'animate-bar-rise' : undefined}
      />
      <rect
        x="34" y="40" width="22" height="10" rx="2" fill="#0A0A0A"
        style={{ ...bar, animationDelay: '320ms' }}
        className={animated ? 'animate-bar-rise' : undefined}
      />
    </svg>
  );
};
